import { trim } from 'lodash-es';

import { IWfaLabel, IWfaSessionDetails } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { ITagGroup } from 'src/common/components/tags-block/TagsBlock';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import { formatDetectionTypesLabel } from './DetectionTypeHelper';

export const getTagsFromSessionDetails = (
	sessionDetails: IWfaSessionDetails,
	overridenLabels?: IWfaLabel[]
): ITagGroup[] => [
	{
		tags: [
			{
				name: 'Date',
				values: [formatShortMonthDatetime(sessionDetails.runTime)]
			},
			{
				name: 'Last modified',
				values: [formatShortMonthDatetime(sessionDetails.lastModifiedTime)]
			},
			{
				name: 'Created by',
				values: [trim(sessionDetails.createdBy) ?? 'N/A']
			},
			{
				name: 'Domain',
				values: [sessionDetails.domain]
			}
		]
	},
	{
		title: 'Session Settings',
		tags: [
			{
				name: 'Session configuration',
				values: [formatDetectionTypesLabel(sessionDetails.detectionTypes)]
			},
			{
				name: 'Focus area',
				values: [sessionDetails.focusArea]
			}
		]
	},
	{
		title: 'Session Labels',
		tags: [
			...(overridenLabels ?? sessionDetails?.labels ?? []).map((label) => ({
				...label,
				values: label.values.map((value) => value.name)
			}))
		]
	}
];
